import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import { BoxArrowInDownRight, X } from 'react-bootstrap-icons';

export default function QBuilderLayoutComponentWrapper({ className = '', defaultLayout = { width: 12, offset: 0, isSet: false }, children, onUpdateLayout, currentMode = 'view' }) {
    const [mode, setMode] = useState(currentMode);
    const [layout, setLayout] = useState(defaultLayout);

    // Keep mode in sync with prop
    useEffect(() => {
        setMode(currentMode);
    }, [currentMode]);

    // Keep layout in sync with prop
    useEffect(() => {
        setLayout(defaultLayout);
    }, [defaultLayout]);

    // Only call onUpdateLayout when layout isSet and changed
    useEffect(() => {
        if (layout.isSet) onUpdateLayout?.(layout);
    }, [layout, onUpdateLayout]);

    const setWidth = useCallback(delta => {
        setLayout(prev => {
            const width = prev.width + delta;
            if (width > 0 && width < 13) return { ...prev, isSet: true, width };
            return prev;
        });
    }, []);

    const setOffset = useCallback(delta => {
        setLayout(prev => {
            const offset = prev.offset + delta;
            if (offset >= 0 && offset < 13) return { ...prev, isSet: true, offset };
            return prev;
        });
    }, []);

    return (
        <>
            <div className={`position-relative ${className}${mode === 'Layout' ? ' bg-primary-container' : ''}`}>
                {mode !== 'Capture' && (
                    <div onClick={() => setMode('Layout')} className="position-absolute" style={{ right: 0 }}>
                        <BoxArrowInDownRight className="me-3" />
                    </div>
                )}
                {children}
            </div>
            {mode === 'Layout' && (
                <div className="bg-secondary-container w-100 position-absolute opacity- shadow p-2" style={{ left: 0, marginTop: 57, zIndex: 99 }}>
                    <div>
                        <div className="text-end">
                            <button onClick={() => setMode('View')} className="btn btn-xs"><X /></button>
                        </div>
                        <div>
                            <b>Width</b> <FontAwesomeIcon onClick={() => setWidth(-1)} icon={faArrowLeft} /> {layout.width} / 12 <FontAwesomeIcon onClick={() => setWidth(1)} icon={faArrowRight} />
                        </div>
                        <div>
                            <b>Offset</b> <FontAwesomeIcon onClick={() => setOffset(-1)} icon={faArrowLeft} /> {layout.offset} / 12 <FontAwesomeIcon onClick={() => setOffset(1)} icon={faArrowRight} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
